import React from 'react';
import { motion } from 'framer-motion';
import { CheckSquare, Clock, Package, Sparkles, Wind, Eye } from 'lucide-react';
const items = [{
  title: 'The 120-Minute Master Timeline',
  desc: 'Exactly what to do from the moment you park your car.',
  icon: Clock
}, {
  title: "The 'Clean Kit' Blueprint",
  desc: 'The only 3 chemicals you need to carry to stop wasting time.',
  icon: Package
}, {
  title: 'The 15-Minute Bathroom Blitz',
  desc: "A specialized sequence to get 'hotel-grade' porcelain fast.",
  icon: Sparkles
}, {
  title: 'The Olfactory Reset',
  desc: "How to make a house smell 'expensive' without using cheap flower sprays.",
  icon: Wind
}, {
  title: 'The Guest-Walk Audit',
  desc: "A 2-minute final pass that catches the 'review-killer' mistakes.",
  icon: Eye
}];
export function WhatYouGet() {
  return <section className="bg-brand-dark py-24 text-white" data-id="element-147">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-148">
        <div className="text-center mb-16" data-id="element-149">
          <h2 className="text-4xl sm:text-5xl text-brand-yellow mb-4" data-id="element-150">
            WHAT YOU GET
          </h2>
          <p className="text-xl text-gray-400" data-id="element-151">
            Everything you need to execute the protocol flawlessly.
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-152">
          {items.map((item, index) => {
          const Icon = item.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className={`bg-white/5 border border-white/10 rounded-xl p-8 hover:border-brand-yellow/50 transition-colors ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-153">
                <div className="bg-brand-yellow/10 w-14 h-14 rounded-lg flex items-center justify-center mb-6" data-id="element-154">
                  <Icon className="w-7 h-7 text-brand-yellow" data-id="element-155" />
                </div>
                <h3 className="text-2xl font-display tracking-wide mb-3" data-id="element-156">
                  {item.title}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-157">{item.desc}</p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}